import CustomButton from "src/core/ui/CustomButton";

export const TourChoiceComponent = ({ choices, setSelectedTour }) => {
  return (
    <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
      {choices.map(choice => (
        <li key={choice.value} style={{ margin: '10px 0' }}>
          <CustomButton onClick={() => setSelectedTour(choice.value)} title={choice.label} variant='outlined' />
        </li>
      ))}
    </ul>
  );
};
